import type { PimFieldValue } from "@thenounproject/lingo-core";
import { createAction } from "@redux/actions/actionCreators";

const [useSetVariantFieldValue, setVariantFieldValue] = createAction<{
  productUuid: string;
  variantKey: string;
  identifier: string;
  value: PimFieldValue;
}>("product/setVariantFieldValue");

export default useSetVariantFieldValue;
export { setVariantFieldValue };
